import type { MapLayerId } from '../../../shared/domain/index.ts';

/**
 * Présentation des calques. Couleurs fonctionnelles de la charte (docs/ui-redesign.md) : bleu transports, orange
 * travaux, violet événements, vert services. Lisibles sur fond clair et sombre grâce au contour blanc.
 */
export interface MapLayerStyle {
  readonly id: MapLayerId;
  readonly label: string;
  readonly color: string;
  /** Regroupement des points proches (calques potentiellement denses). */
  readonly cluster: boolean;
  readonly defaultEnabled: boolean;
}

export const MAP_LAYERS: readonly MapLayerStyle[] = [
  { id: 'transport', label: 'Transports', color: '#0a6fe8', cluster: false, defaultEnabled: true },
  { id: 'roadworks', label: 'Travaux', color: '#c2410c', cluster: true, defaultEnabled: true },
  { id: 'events', label: 'Événements', color: '#7c3aed', cluster: true, defaultEnabled: true },
  { id: 'services', label: 'Services', color: '#15803d', cluster: true, defaultEnabled: true },
  { id: 'shops', label: 'Commerces', color: '#b45309', cluster: true, defaultEnabled: false },
  { id: 'reports', label: 'Signalements', color: '#c81e1e', cluster: true, defaultEnabled: false },
];

const DEFAULT_STYLE = 'https://tiles.openfreemap.org/styles/positron';
const DEFAULT_STYLE_DARK = 'https://tiles.openfreemap.org/styles/dark';

/** Style de fond de carte configurable (ADR-0007). */
export function mapStyleUrl(dark: boolean): string {
  const env = import.meta.env;
  const light = env.VITE_MAP_STYLE_URL || DEFAULT_STYLE;
  return dark ? env.VITE_MAP_STYLE_URL_DARK || DEFAULT_STYLE_DARK : light;
}
